<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasMonitorPerm.value" :to="{name: 'monitors'}">Monitor</v-btn>
            <v-btn v-if="hasGatewayPerm.value" :to="{name: 'gateway'}">Gateway</v-btn>
            <v-btn v-if="hasRecursosPerm.value" :to="{name: 'recursos'}">Controle de Recursos</v-btn>
            <v-btn v-if="hasDockersPerm.value" :to="{name: 'dockers'}">Docker</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
import { ref, computed } from 'vue';
import  { useRouter } from 'vue-router';
const hasGatewayPerm = ref(false)
const hasMonitorPerm = ref(false)
const hasRecursosPerm = ref(false)
const hasDockersPerm = ref(false)
const router = useRouter();
hasMonitorPerm.value = computed(() => router.resolve({name: 'monitors'}).meta.has_perm())
hasGatewayPerm.value = computed(() => router.resolve({name: 'gateway'}).meta.has_perm())
hasRecursosPerm.value = computed(() => router.resolve({name: 'recursos'}).meta.has_perm())
hasDockersPerm.value = computed(() => router.resolve({name: 'dockers'}).meta.has_perm())
</script>